module.exports = __webpack_public_path__ + "img/endodontic-therapy.4643cf1b.svg";